import { useEffect, useState } from "react";
import { callApiValidateSession } from "../api/validateSession";
import { WBToken } from "./../app/types/types";
import { useUserStore, UIConfig } from "../stores/userStore";
import { UserSessionResponse } from "../app/types/sessionTypes";

const SESSION_KEY = "s";

export const useValidateSession = (token: string | null) => {
  // Usa Zustand invece di Redux
  const { user, setUser, resetUser, setAppConfig, resetAppConfig } = useUserStore();
  const [errorMessage, setErrorMessage] = useState("");
  const [onError, setOnError] = useState(false);
  const [onLoading, setOnLoading] = useState(false);

  const updateSession = async (_user: UserSessionResponse, _uiConfig?: UIConfig) => {
    setUser(_user);
    if (_uiConfig) {
      setAppConfig(_uiConfig);
    }
  };

  useEffect(() => {
    const validateSession = async (d: string) => {
      setOnLoading(true);
      
      try {
        const response = await callApiValidateSession(d);
        
        // Estrai configurazione UI dalla risposta se presente
        const { uiConfig, ...userData } = response as WBToken & { uiConfig?: UIConfig };
        
        // Salva dati utente
        setUser(userData as UserSessionResponse);
        
        // Salva configurazione UI se presente
        if (uiConfig) {
          setAppConfig(uiConfig);
        }
        
        setOnError(false);
        setErrorMessage("");
        
      } catch (err: any) {
        console.error("❌ [useValidateSession] Errore durante validazione:", err);
        console.error("❌ [useValidateSession] Errore dettagli:", err.message);
        
        resetUser();
        resetAppConfig();
        setOnError(true);
        setErrorMessage(err.message || "Errore durante la validazione");
        
      } finally {
        setOnLoading(false);
      }
    };

    // Logica di validazione
    if (token && checkToken(token) && user.d.length === 0) {
      validateSession(token);
    } else if (user?.d === "") {
      resetAppConfig(); // Reset anche configurazioni UI
      setOnError(true);
      setErrorMessage("Sessione scaduta");
    } else {

    }
  }, [token, user.d, setUser, resetUser, setAppConfig, resetAppConfig]);

  return { user, onLoading, onError, errorMessage, updateSession };
};

export const setLocalSession = (token: WBToken) => {
  window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(token));
};

export const getLocalSession = () => {
  const session = window.sessionStorage.getItem(SESSION_KEY);
  if (session) {
    return JSON.parse(session);
  }
};

const checkToken = (token: string | null): boolean => {
  if (token === null || token === undefined) {
    return false;
  }
  return true;
};
